import { render, staticRenderFns } from "./UpdateRow.vue?vue&type=template&id=1e6bd6c6&"
import script from "./UpdateRow.vue?vue&type=script&lang=js&"
export * from "./UpdateRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports